import { CEProductAttributesBase } from './ce-product-attributes-base'


export class CEProductAttributes extends CEProductAttributesBase {

}